import React from "react";
import { CardSelected } from "../../../type";
import { LabelStyled } from "../../common/common.style";
import { lettersToNumber, useAddCommas } from "../../../utils";
import { Box, FlexBox } from "../../primitives";
import { Container, Wrapper } from "./subHeader.styled";
import ErrorIconWithTooltip from "../../common/ErrorIconWithTooltip/ErrorIconWithTooltip";

interface SubHeaderProps {
  cardsBoard: CardSelected[];
  hasFailedCards: boolean;
}

export const SubHeader = ({ cardsBoard, hasFailedCards }: SubHeaderProps) => {
  const addCommas = useAddCommas();
  const totalPrice = cardsBoard.reduce((total, card) => {
    const price = card.price ?? 0;
    return total + price * card.quantity;
  }, 0);

  const totalOriginalPrice = cardsBoard.reduce((total, card) => {
    const price = card.originalPrice ?? 0;
    return total + price * card.quantity;
  }, 0);

  const totalQuantity = cardsBoard.reduce((total, card) => {
    const quantity = card.quantity ?? 0;
    return total + quantity;
  }, 0);

  const totalPurchasePrice = cardsBoard.reduce((total, card) => {
    const commentSanitize = card?.description
      ?.slice(card?.description?.lastIndexOf("!") + 1)
      .trim();

    let rest = commentSanitize?.substring(0, commentSanitize?.indexOf("-"));

    return total + parseFloat(lettersToNumber(rest)) * card.quantity;
  }, 0);

  return (
    <Container>
      <Wrapper>
        {totalPrice !== totalOriginalPrice && (
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <LabelStyled css={{ marginBottom: 0 }}>ORIGINAL PRICE:</LabelStyled>
            <Box>{addCommas(totalOriginalPrice?.toFixed(2))} €</Box>
          </FlexBox>
        )}
        <FlexBox css={{ alignItems: "center", gap: 10 }}>
          <LabelStyled css={{ marginBottom: 0 }}>TOT PRICE:</LabelStyled>
          <Box>{addCommas(totalPrice?.toFixed(2))} €</Box>
        </FlexBox>
        <FlexBox css={{ alignItems: "center", gap: 10 }}>
          <LabelStyled css={{ marginBottom: 0 }}>TOT QUANTITY:</LabelStyled>
          <Box>
            {addCommas(cardsBoard?.length || 0)} ({addCommas(totalQuantity)})
          </Box>
        </FlexBox>
        {totalPurchasePrice ? (
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <LabelStyled css={{ marginBottom: 0 }}>
              TOT PURCHASE PRICE:
            </LabelStyled>
            <Box>{addCommas(totalPurchasePrice.toFixed(2))} €</Box>
          </FlexBox>
        ) : null}
        {totalPurchasePrice ? (
          <FlexBox css={{ alignItems: "center", gap: 10 }}>
            <LabelStyled css={{ marginBottom: 0 }}>
              POTENTIAL PROFIT:
            </LabelStyled>
            <Box>
              {addCommas((totalPrice - totalPurchasePrice).toFixed(2))} €
            </Box>
          </FlexBox>
        ) : null}
        {hasFailedCards && (
          <FlexBox css={{ justifyContent: "center" }}>
            <ErrorIconWithTooltip message="there are some price issue" />
          </FlexBox>
        )}
      </Wrapper>
    </Container>
  );
};
